"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  fragment ProductListingRows on EditorialPlpRowsContent {\n    totalBannersCount\n    totalProductsCount\n    orderByOptions {\n      ...OrderByOptions\n    }\n    facets {\n      ...ProductListingFacets\n    }\n    rows @skip(if: $hasFilters) {\n      __typename\n      ...ProductListingRow\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productListingRows = void 0;
var _fetching = require("@ori/fetching");
var _orderByOptions = require("./orderByOptions");
var _productListingFacets = require("./productListingFacets");
var _productListingRow = require("./productListingRow");
const productListingRows = exports.productListingRows = (0, _fetching.gql)(_templateObject(), _productListingRow.productListingRow, _orderByOptions.orderByOptions, _productListingFacets.productListingFacets);
